export default "__VITE_ASSET__lt$yfwFt__"